/* eslint-disable */
<template>
    <div id="app" class="raiz">
        <div class="vis-header">
            <h4>Where could arabica coffee be grown in the future?</h4>
            <p>The increase in temperatures will mean that coffee could no longer be grown in some areas. This map shows
                the changes projected for 2050 in the viability of the Coffea arabica crop due to climate change.
            </p>
        </div>

        <div class="vis-body">
            <div class="vis-content">
                <div id="map"></div>
                <div id='state-legend' class='legend'>
                    <div>
                        <span style='background-color: #E11519'></span>Much less suitable&nbsp;
                        <span style='background-color: #FEB667'></span>Little less suitable&nbsp;
                        <span style='background-color: #FFFFC7'></span>Barely suitable&nbsp;
                        <span style='background-color: #B2E6AB'></span>No change&nbsp;
                        <span style='background-color: #298CC1'></span>More suitable&nbsp;
                    </div>
                </div>
            </div>
        </div>

        <div class="vis-footer">
            <p>
                <small><a href="https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0124155" target="_blank">Source: CIAT, International Center for Tropical Agriculture.</a></small>
            </p>
        </div>
    </div>
</template>

<script>

    import * as mapboxgl from 'mapbox-gl';

    export default {
        name: 'app',
        components: {},
        data: () => {
            return {}
        },

        mounted: function () {
            this.loadData();
            this.drawVis();
        },

        methods: {
            loadData: function () {

            },

            drawVis: function () {
                let vm = this;

                mapboxgl.accessToken = "pk.eyJ1Ijoib3NjYXJhbCIsImEiOiJjanBsa3d4YnUwZmJiNDJubG14bmdtemZvIn0.MEhhIa67a_7R8FHDAEoPFg";

                var map = new mapboxgl.Map({
                    container: 'map',
                    style: 'mapbox://styles/oscaral/cjyanzgzj0frp1cl09v7567l2',
                    center: [-69.411, 0.844],
                    zoom: 2.5
                });

                let attributtionControl = new mapboxgl.AttributionControl({
                    compact: true,
                    customAttribution: "International Center for Tropical Agriculture"
                });

                map.addControl(attributtionControl);
                map.addControl(new mapboxgl.NavigationControl(), 'top-right');
                map.addControl(new mapboxgl.FullscreenControl());

                var stateLegendEl = document.getElementById('state-legend');

            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~bulma/bulma";
    @import 'assets/typography';

    #app {
        font-family: 'Open Sans', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #222;
        max-width: 720px;
        margin: 0 auto;
        padding: 15px 5px;

        border-top: 2px solid #3C3B3B;

        @include mobile {
            padding: 15px 10px;
        }
    }

    div.vis-header {
        h3, h4 {
            margin-top: 0;
        }

        p {

        }
    }

    div.vis-controls {
        margin-top: 20px;
    }

    div.vis-body {
        min-height: 100px;
        margin-top: 0;
    }

    div.vis-footnote {
        font-size: 14px;
        line-height: 16px;
        margin-top: 20px;
    }

    div.vis-footer {
        margin-top: 10px;
        padding: 5px 0;
        border-top: 1px solid grey;

        p {
            margin-bottom: 0;
        }
    }

    #map {
        width: 100%;
        height: 500px;
    }

    // Leyenda
    .legend {
        background-color: #fff;
        border-radius: 3px;
        bottom: 30px;
        box-shadow: 0 1px 2px rgba(0,0,0,0.10);
        font: 12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif;
        padding: 10px;
        //position: absolute;
        right: 10px;
        top: 10px;
        z-index: 1;
    }

    .legend h4 {
        margin: 0 0 10px;
    }

    .legend div span {
        border-radius: 50%;
        display: inline-block;
        height: 10px;
        margin-right: 5px;
        width: 10px;
    }

</style>
